import {del, get, post, put} from './capitalAxios';

const BASE = '/api/v1/currency-rate';

export const findAllCurrencyRates = () => get(BASE);
export const createCurrencyRate = (body) => post(BASE, body);
export const updateCurrencyRate = (id, body) => put(`${BASE}/${id}`, body);
export const deleteCurrencyRate = (id) => del(`${BASE}/${id}`);
